import Quill from 'quill';
import { isMaintellaMediaUrl } from '../../shared/utils/mediaLibraryUrls';

let registered = false;

/**
 * Quill's default image blot only allows http/https/data URLs.
 * Workflow library images use maintella-media://{id} in stored HTML.
 */
export function registerWorkflowQuillImage() {
  if (registered) return;

  const BaseImage = Quill.import('formats/image');

  class WorkflowImage extends BaseImage {
    static sanitize(url) {
      if (isMaintellaMediaUrl(url)) return url;
      return BaseImage.sanitize(url);
    }
  }

  Quill.register(WorkflowImage, true);
  registered = true;
}
